export const formatDate = (inputDateStr:string) => {
  const inputDate = new Date(inputDateStr);

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];

  const year = inputDate.getFullYear();
  const month = months[inputDate.getMonth()];
  const day = inputDate.getDate();
  const hour = inputDate.getHours();
  const minute = inputDate.getMinutes();

  // Format hour in 12-hour format with AM/PM
  const period = hour >= 12 ? 'PM' : 'AM';
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12;

  // Format minute with leading zero if needed
  const formattedMinute = minute < 10 ? `0${minute}` : minute;

  return `${month} ${day}, ${year} | ${formattedHour}:${formattedMinute} ${period}`;
};
